import * as tslib_1 from "tslib";
import { BaseService } from '../../_helpers';
import { HttpClient } from '@angular/common/http';
import { DictionaryEntity } from '../entity';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DeviceTypeDictionaryService = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceTypeDictionaryService, _super);
    function DeviceTypeDictionaryService(http) {
        var _this = _super.call(this, 'config/deviceTypes/idAndNames', DictionaryEntity) || this;
        _this.http = http;
        return _this;
    }
    DeviceTypeDictionaryService.ngInjectableDef = i0.defineInjectable({ factory: function DeviceTypeDictionaryService_Factory() { return new DeviceTypeDictionaryService(i0.inject(i1.HttpClient)); }, token: DeviceTypeDictionaryService, providedIn: "root" });
    return DeviceTypeDictionaryService;
}(BaseService));
export { DeviceTypeDictionaryService };
